
class AddPreBuiltBundle extends HTMLElement {
	constructor() {
		super();
		this.button = this.querySelector("button");
		this.button?.addEventListener("click", (e) => this.onClick(e));
	}

	onClick(e) {
    e.preventDefault();
    e.stopPropagation();

    const bab = document.querySelector("build-a-box");
    bab?.openPresetBundle(this.dataset.title);
  }
}

export { AddPreBuiltBundle };
